import React, {useEffect, useState, useContext, useMemo} from 'react';
import AppContext, {
  CONNECTION_STATUS_DEFAULT as DEFAULT,
  CONNECTION_STATUS_DISCONNECTED as DISCONNECTED,
  CONNECTION_STATUS_RECONNECTION as RECONNECTION
} from "../../store";
import {formatIndex} from '../../helpers/index';
import {
  EVENT_UPDATE_QUEUE_DATA,
  webRTCObserver
} from '../Configurator/hooks/useConfiguratorMount';
import {TEXT_EMPTY, TEXT_SECONDS_PLURAL, TEXT_SECONDS_SINGLE} from '../../contants/common';
import './WelcomeHolder.scss';
import LogoArcware from '../../assets/images/Arcware_Logo.svg';
import LogoMifcom from '../../assets/images/MIFCOM_Logo.svg';
import useInterval from "../../hooks/useInterval";
import InteractionsList from '../Interactions/InteractionsList.jsx';
import {ConfiguratorButton, TYPE_CONFIGURATOR_BUTTON_HUGE} from '../Configurator/ConfiguratorsPanel';
import Spinner from '../Spinner/Spinner';
import {TIME_DISCONNECT_SECONDS} from "../PopupIdle/PopupIdle";
import {
  INTERACTION_ID_MOUSE_ACTION,
  INTERACTION_ID_FINGER_ACTION,
  INTERACTION_ID_FINGER_CAMERA_ROTATE,
  INTERACTION_ID_MOUSE_ZOOM,
  INTERACTION_ID_FINGER_ZOOM,
  INTERACTION_ID_FINGER_CHANGE_VIEW,
} from "../Interactions/constants";

const interactionIdsDesktop = [
  INTERACTION_ID_MOUSE_ACTION,
  INTERACTION_ID_MOUSE_ZOOM,
];

const interactionIdsMobile = [
  INTERACTION_ID_FINGER_CAMERA_ROTATE,
  INTERACTION_ID_FINGER_ACTION,
  INTERACTION_ID_FINGER_ZOOM,
  INTERACTION_ID_FINGER_CHANGE_VIEW,
];

const TIME_UPDATE_DATA_SECONDS = 1000;
const TIME_INITIAL_REMAINING_SECONDS = 10;

const getRemainingSeconds = seconds => {
  return seconds > 1 ? TEXT_SECONDS_PLURAL : TEXT_SECONDS_SINGLE
}

function StatusDefault() {
  const {
    queueData: {index}, /*estimatedWaitTime*/
    setQueueData,
    isConfiguratorAvailable,
  } = useContext(AppContext);
  const [prevIndex, setPrevIndex] = useState(0);
  const [remaining, setRemaining] = useState(TIME_INITIAL_REMAINING_SECONDS);
  const [progress, setProgress] = useState(0);

  useInterval(() => {
    setRemaining(v => v === 0 ? 10 : v - 1);
  }, isConfiguratorAvailable ? null : TIME_UPDATE_DATA_SECONDS);

  const handleUpdateQueueData = function (res) {
    const {index, queueLength, valueType = 'minutes'} = res;  /*estimatedWaitTime*/
    setPrevIndex(index);
    setQueueData({
      index,
      queueLength,
      // estimatedWaitTime: `${Math.round(estimatedWaitTime)} ${determineTimeValue(valueType, estimatedWaitTime)}`,
    });
    if ([index, queueLength].every(Number.isFinite.bind(Number))) {
      setProgress(100 - (100 * (index || 1) / (queueLength || 1)));
    }
    if (Number.isFinite(index)) {
      setRemaining(TIME_INITIAL_REMAINING_SECONDS);
    }
  }
  
  const renderIndex = useMemo(() => {
    const prevIndexBiggerThanZero = prevIndex > 0;
    return Number.isFinite(index) && prevIndexBiggerThanZero
      ? formatIndex(index)
      : TEXT_EMPTY
  }, [index, prevIndex]);
  
  const textRemainingSeconds = getRemainingSeconds(remaining);
  
  useEffect(() => {
    window.handleUpdateQueueData = handleUpdateQueueData; /*@TODO For debug*/
    webRTCObserver.subscribe(EVENT_UPDATE_QUEUE_DATA, handleUpdateQueueData);
  }, []);
  
  return (
    <>
      <div className="welcome-infoQueue">
        <p>Du bist der <span id="queue-place" className="welcome-infoQueue-place">
                    {renderIndex}
                  </span>
        </p>
        <p>in der Warteschlange.</p>
      </div>
      <span className="welcome-infoProgressbar">
						      <span className="welcome-infoProgressbar-fill" style={{width: `${progress}%`}}></span>
					      </span>
      {/*{*/}
      {/*  estimatedWaitTime && <div className="welcome-infoTimeText">*/}
      {/*    Deine geschätzte Wartezeit beträgt <span id="queue-time">{estimatedWaitTime || "?"}</span>*/}
      {/*  </div>*/}
      {/*}*/}
      <div className="welcome-infoCommon">
        <p>Aufgrund der hohen Nachfrage wurdest du in eine automatische Warteschlange platziert.
          Bleibe einfach
          dran
          und schließe die Seite nicht.</p>
        <p>Diese Seite wird automatisch in {remaining} {textRemainingSeconds} aktualisiert...</p>
      </div>
    </>
  )
}

function StatusConnecting() {
  const {
    setConnectionStatus,
    toggleStream,
  } = useContext(AppContext)
  const [remaining, setRemaining] = useState(TIME_DISCONNECT_SECONDS);
  const textRemainingSeconds = useMemo(() => getRemainingSeconds(remaining), [remaining]);
  
  const handleReconnect = () => {
    setConnectionStatus(DEFAULT)
    toggleStream(true)
    console.log(`Connection status: ${DEFAULT}`)
  }
  
  useInterval(() => {
    setRemaining(v => v - 1);
  }, 1000)
  
  useEffect(() => {
    if(remaining === 0) {
      setConnectionStatus(DISCONNECTED)
    }
  }, [remaining])
  
  return (
    <>
      <div className="welcome-infoTimeText"><p>Du wirst in {remaining} {textRemainingSeconds} ausgeloggt</p></div>
      <ConfiguratorButton
        onClick={handleReconnect}
        type={TYPE_CONFIGURATOR_BUTTON_HUGE}>
        <div className="welcome-align-spinner welcome-infoCommon">
          <p className="text">Zurück zur 3D-Experience</p>
          <Spinner></Spinner>
        </div>
      </ConfiguratorButton>
    </>
  )
}

function StatusDisconnected() {
  useEffect(() => {
    localStorage.removeItem('sessionId');
  }, [])
  return (
    <>
      <div className="welcome-infoTimeText">
        <p>Ihre Verbindung wurde getrennt, bitte laden Sie die Seite neu.</p>
      </div>
      <ConfiguratorButton
        onClick={window.location.reload.bind(window.location)}
        type={TYPE_CONFIGURATOR_BUTTON_HUGE}>
        <div className="welcome-infoCommon">
          <p className="text">Neu laden</p>
        </div>
      </ConfiguratorButton>
    </>
  )
}

const WELCOME_TEXT_DEFAULT = 'Willkommen';
const WELCOME_TEXT_CONNECTION = 'Inaktivität';

export default function WelcomeHolder() {
  const {connectionStatus} = useContext(AppContext);
  const welcomeText = useMemo(() => {
    return connectionStatus === DEFAULT
      ? WELCOME_TEXT_DEFAULT
      : WELCOME_TEXT_CONNECTION
  }, [connectionStatus]);

  return (
    <div className="welcome-container">
      <div className="welcome-inner">
        <div className="welcome-projectMoto visible-device-big">
          <span>getonmylvl</span>
          <span className="bold">3d-experience</span>
        </div>
        
        <div className="welcome-infoWrap">
          <div className="welcome-infoTitle welcome-underscore welcome-underscore--primary">{welcomeText}</div>
          <div className="welcome-infoContent">
            { /* Connection */
              connectionStatus === DEFAULT && <StatusDefault />
            }
            
            { /*Reconnection*/ }
            {
              connectionStatus === RECONNECTION && <StatusConnecting />
            }

            {/*Out of the queue*/}
            {
              connectionStatus === DISCONNECTED && <StatusDisconnected />
            }
          </div>
        </div>
        
        <InteractionsList
          mobileIds={interactionIdsMobile}
          desktopIds={interactionIdsDesktop}
          className={"interactions-list-on-welcome-page"}
        />
        
        <div className="welcome-copyright visible-device-big">
          <ul className="welcome-copyright-logoList">
            <li className="welcome-copyright-logoItem">
              <img src={LogoArcware} alt="Arcware logo" className="welcome-copyright-logoImg"/>
            </li>
            <li className="welcome-copyright-logoItem">
              <img src={LogoMifcom} alt="MIFCOM logo" className="welcome-copyright-logoImg"/>
            </li>
          </ul>
          <div className="welcome-copyright-text">
            <p>Copyright © ARCWARE GmbH | MIFCOM GmbH | Alle Inhalte dieses Internet Angebots unterliegen
              dem</p>
            <p>Urheberrecht. Jede Entnahme und Weiterverwendung auch auszugsweise ist ohne vorherige
              Zustimmung
              untersagt.</p>
          </div>
        </div>
      </div>
    </div>
  )
}
